module.exports = __webpack_public_path__ + "static/media/facebook.d34174e3.svg";